import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { State, StateList } from 'src/app/shared/state-list';
import { FipsList } from 'src/app/shared/state_county_fips';
import { Form_Qns } from '../../shared/single_submit_form_questions';
import { Router } from '@angular/router';
import { MyListingsService } from '../../services/my-listings.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { ToastService, ToastType } from '../../services/toast.service';
import { ListingLeadsService } from '../../services/listing-leads.service';
import { HeaderComponent } from '../header/header.component';
import { AppState } from 'src/app/app.state';
import { MatDialog } from '@angular/material/dialog';
import { StepperSaveComponent } from '../stepper-save/stepper-save.component';
import { UserState } from 'src/state/user.state';
import { UserService } from 'src/app/services/user.service';
import { DynamicFormService } from 'src/app/services/dynamic-form.service';
import constants from 'src/constants.json';
import { ActivityLoggerService } from 'src/app/services/activity-logger.service';
@Component({
  selector: 'app-home-details',
  templateUrl: './home-details.component.html',
  styleUrls: ['./home-details.component.css'],
})
export class HomeDetailsComponent implements OnDestroy {
  @ViewChild(HeaderComponent) header: HeaderComponent;
  @ViewChild(StepperSaveComponent) stepperSaveComponent!: StepperSaveComponent;
  @ViewChild('confirmationDialog', { static: true }) confirmationDialog: any;
  private destroy$ = new Subject<void>();

  basicHomeData: {};
  BedroomsTotal: any;
  BathroomsFull: any;
  BathroomsHalf: any;
  ParcelNumber: String;
  LotSizeSqFt: string;
  PropertySubType: any;
  LivingArea: any;
  Heating: [];
  Cooling: [];
  Basement: any;
  Stories: any;
  countyList = [];
  onDestroyNotifier$ = new Subject();
  dialogRef: any;
  myHomeDetails: any;
  closeFlag: string;
  saveFlag: string;
  historyState: any;
  myListingId: string;
  isLoader: boolean = false;
  isButtonLoader: boolean = false;
  hideContinue: boolean = false;
  isPageLoaded: boolean = false;
  stateList: State[] = StateList;
  submitFlag: string;
  isScreenWidthLarge: boolean = false;
  listingCheckoutEnabled: boolean = false;
  formConfig: any;
  formControlTouch: boolean;
  hidePlanSelection: boolean = false;

  constructor(
    private router: Router,
    public localStorageService: LocalStorageService,
    public myListingsService: MyListingsService,
    public toastService: ToastService,
    public listingLeadsService: ListingLeadsService,
    public appState: AppState,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    public userState: UserState,
    private userService: UserService,
    public formService: DynamicFormService,
    private activityLoggerService: ActivityLoggerService
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isScreenWidthLarge = window.innerWidth > 768;
  }

  ngOnInit(): void {
    this.isScreenWidthLarge = window.innerWidth > 768;

    this.formService
      .getFormSuccessObservable()
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data) {
          this.isLoader = true;
          this.updateListings(data);
        }
      });

    this.formService.getFormErrorObservable().subscribe((errors) => {
      if (errors) {
        this.toastService.toast(
          'Mandatory fields are not filled',
          ToastType.Warning
        );
      }
    });

    this.appState.companyInfo$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res) => {
        if (res) {
          /* for testing new form questions comment the if and use the else section, 
          edit the questions in single_form_questions.ts file 
          and after completing update the same in sellSideConfig against company*/
          this.hidePlanSelection =
            res?.sellSideConfig?.hidePlanSelection || false;

          if (res?.sellSideConfig && res?.sellSideConfig?.singleFormQuestions) {
            this.formConfig = res.sellSideConfig.singleFormQuestions;
          } else {
            this.formConfig = Form_Qns;
          }

          if (
            res?.sellSideConfig &&
            res?.sellSideConfig?.listingServiceProvider == 'ListingCheckout'
          ) {
            this.listingCheckoutEnabled = true;
          } else {
            this.listingCheckoutEnabled = false;
          }
        }
        this.cdr.detectChanges();
      });

    this.historyState = history.state;
    if (!this.historyState.address) {
      this.router.navigateByUrl('/my-listing');
      return;
    }

    this.myListingId = this.historyState.myListingId
      ? this.historyState.myListingId
      : this.localStorageService.get('myListingId')
      ? this.localStorageService.get('myListingId')
      : null;

    this.userState.userDetails
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res) => {
        if (res) {
          if (this.historyState && this.historyState.basicHomeData) {
            this.findCountyList(this.historyState.StateOrProvince);
            this.showPreSelectedValue(this.historyState.basicHomeData);
          } else {
            let userId = res.id;
            if (
              this.historyState &&
              (this.historyState.completedIndex == 1 ||
                this.myListingId != null)
            ) {
              this.setBasicHomeData(userId);
            } else {
              this.isButtonLoader = true;
              let input = {
                where: {
                  userId: userId,
                  matchAddress: this.historyState.matchAddress,
                },
              };
              this.myListingsService.GetListings(input).subscribe({
                next: (res) => {
                  if (res && res.length > 0) {
                    this.isButtonLoader = false;
                    this.router.navigateByUrl('/my-listing', {
                      state: this.historyState,
                    });
                    this.toastService.toast(
                      'A listing with same property address is pending in your My Listings',
                      ToastType.Warning
                    );
                  } else {
                    this.isButtonLoader = false;
                    this.setBasicHomeData(userId);
                  }
                },
                error: (err) => {
                  this.isButtonLoader = false;
                  this.setBasicHomeData(userId);
                },
              });
            }
          }
        }
      });

    if (this.historyState.ListingLeadId) {
      let userId = this.userState?.getUserDetails?.id;
      let input = {
        userId: userId,
        listingId: this.myListingId,
        updatedDate: new Date(),
      };

      input = this.filterInputJson(input);

      this.listingLeadsService
        .UpdateListingLeads(this.historyState.ListingLeadId, input)
        .subscribe({
          next: (res) => {},
          error: (err) => {
            console.log('UpdateListingLeads err!!!!', err);
          },
        });
    }

    if (
      !this.userState?.getUserDetails ||
      !this.userState?.getUserDetails?.id
    ) {
      let userEmail = this.userState?.getUserDetails?.email;
      if (userEmail && this.header) {
        this.header.getUserInfo(userEmail);
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  showPreSelectedValue(historyValue) {
    this.isPageLoaded = true;
    let formConfig = this.formConfig.map((field) => {
      if (historyValue[field.name] != null) {
        let processedValue;
        if (field.type == 'chip-list' && historyValue[field.name] != null) {
          if (typeof historyValue[field.name] === 'string') {
            processedValue = historyValue[field.name]
              .split(',') // Split the string by commas into an array
              .map((item) => item.trim()); // Trim any extra spaces from each item
          } else {
            processedValue = historyValue[field.name]; // Assume it's already an array
          }
          return {
            ...field,
            value: processedValue, // Ensure the value is an actual array
          };
        } else if (
          field.type == 'currency' &&
          historyValue[field.name] != null &&
          typeof historyValue[field.name] == 'number'
        ) {
          let newVal = historyValue[field.name].toString();
          newVal = newVal.replace(/,/g, '');
          newVal = newVal.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return {
            ...field,
            value: newVal, // Ensure the value is an actual array
          };
        } else {
          return {
            ...field,
            value: historyValue[field.name],
          };
        }
      } else {
        return field; // Return unchanged if no matching data is found
      }
    });
    setTimeout(() => {
      this.formConfig = formConfig;
      this.isPageLoaded = false;
    }, 1000); // for setting the value in dynamic form
  }

  findCountyList(state) {
    this.countyList = FipsList.filter((x) => x.stateorprovince == state);
  }

  setBasicHomeData(userId) {
    this.Stories = null;
    this.LivingArea = null;
    this.ParcelNumber = null;

    if (
      this.historyState.listingDetails &&
      this.historyState.listingDetails.ParcelNumber
    ) {
      this.ParcelNumber = this.historyState.listingDetails.ParcelNumber;
    } else if (
      this.historyState.propertyDetails &&
      this.historyState.propertyDetails.ParcelNumber
    ) {
      this.ParcelNumber = this.historyState.propertyDetails.ParcelNumber;
    } else {
      this.ParcelNumber = null;
    }

    this.historyState['ParcelNumber'] = this.ParcelNumber;

    if (
      this.historyState.listingDetails &&
      this.historyState.listingDetails.StoriesTotal
    ) {
      if (typeof this.historyState.listingDetails.StoriesTotal == 'string') {
        this.Stories = parseInt(this.historyState.listingDetails.StoriesTotal);
      } else {
        this.Stories = this.historyState.listingDetails.StoriesTotal;
      }
    } else if (
      this.historyState.propertyDetails &&
      this.historyState.propertyDetails.StoriesTotal
    ) {
      if (typeof this.historyState.propertyDetails.StoriesTotal == 'string') {
        this.Stories = parseInt(this.historyState.propertyDetails.StoriesTotal);
      } else {
        this.Stories = this.historyState.propertyDetails.StoriesTotal;
      }
    } else {
      this.Stories = null;
    }

    this.findCountyList(this.historyState.StateOrProvince);

    if (this.historyState.myHomeId) {
      this.showMyHomeDetails(this.historyState.myHomeId);
    } else {
      if (
        this.historyState.listingDetails &&
        this.historyState.listingDetails.LivingArea
      ) {
        if (typeof this.historyState.listingDetails.LivingArea == 'string') {
          this.LivingArea = parseInt(
            this.historyState.listingDetails.LivingArea
          );
        } else {
          this.LivingArea = this.historyState.listingDetails.LivingArea;
        }
      } else if (
        this.historyState.propertyDetails &&
        this.historyState.propertyDetails.LivingArea
      ) {
        if (typeof this.historyState.propertyDetails.LivingArea == 'string') {
          this.LivingArea = parseInt(
            this.historyState.propertyDetails.LivingArea
          );
        } else {
          this.LivingArea = this.historyState.propertyDetails.LivingArea;
        }
      } else {
        this.LivingArea = null;
      }

      if (
        this.historyState.listingDetails ||
        this.historyState.propertyDetails
      ) {
        this.BedroomsTotal =
          this.historyState.listingDetails &&
          this.historyState.listingDetails.BedroomsTotal
            ? typeof this.historyState.listingDetails.BedroomsTotal == 'string'
              ? parseInt(this.historyState.listingDetails.BedroomsTotal)
              : this.historyState.listingDetails.BedroomsTotal
            : this.historyState.propertyDetails &&
              this.historyState.propertyDetails.BedroomsTotal
            ? typeof this.historyState.propertyDetails.BedroomsTotal == 'string'
              ? parseInt(this.historyState.propertyDetails.BedroomsTotal)
              : this.historyState.propertyDetails.BedroomsTotal
            : null;
        this.BathroomsHalf =
          this.historyState.listingDetails &&
          this.historyState.listingDetails.BathroomsDecimal
            ? typeof this.historyState.listingDetails.BathroomsDecimal ==
              'string'
              ? parseInt(this.historyState.listingDetails.BathroomsDecimal)
              : this.historyState.listingDetails.BathroomsDecimal
            : this.historyState.propertyDetails &&
              this.historyState.propertyDetails.BathroomsPartial
            ? typeof this.historyState.propertyDetails.BathroomsPartial ==
              'string'
              ? parseInt(this.historyState.propertyDetails.BathroomsPartial)
              : this.historyState.propertyDetails.BathroomsPartial
            : null;
        this.BathroomsFull =
          this.historyState.listingDetails &&
          this.historyState.listingDetails.BathroomsTotalInteger
            ? typeof this.historyState.listingDetails.BathroomsTotalInteger ==
              'string'
              ? parseInt(this.historyState.listingDetails.BathroomsTotalInteger)
              : this.historyState.listingDetails.BathroomsTotalInteger
            : this.historyState.propertyDetails &&
              this.historyState.propertyDetails.BathroomsFull
            ? typeof this.historyState.propertyDetails.BathroomsFull == 'string'
              ? parseInt(this.historyState.propertyDetails.BathroomsFull)
              : this.historyState.propertyDetails.BathroomsFull
            : null;
        this.LotSizeSqFt =
          this.historyState.listingDetails &&
          this.historyState.listingDetails.LotSizeSquareFeet
            ? typeof this.historyState.listingDetails.LotSizeSquareFeet ==
              'string'
              ? parseInt(this.historyState.listingDetails.LotSizeSquareFeet)
              : this.historyState.listingDetails.LotSizeSquareFeet
            : this.historyState.propertyDetails &&
              this.historyState.propertyDetails.LotSizeSquareFeet
            ? typeof this.historyState.propertyDetails.LotSizeSquareFeet ==
              'string'
              ? parseInt(this.historyState.propertyDetails.LotSizeSquareFeet)
              : this.historyState.propertyDetails.LotSizeSquareFeet
            : null;
      }

      if (
        this.historyState.PropertySubType &&
        (this.historyState.PropertySubType.toLowerCase() ==
          'single family residence' ||
          this.historyState.PropertySubType.toLowerCase() == 'house')
      ) {
        this.PropertySubType = 'HOUSE';
      } else if (
        this.historyState.PropertySubType &&
        (this.historyState.PropertySubType.toLowerCase() == 'condominium' ||
          this.historyState.PropertySubType.toLowerCase() == 'condo')
      ) {
        this.PropertySubType = 'CONDO';
      } else if (
        this.historyState.PropertySubType &&
        (this.historyState.PropertySubType.toLowerCase() == 'quadruplex' ||
          this.historyState.PropertySubType.toLowerCase() == 'duplex/triplex')
      ) {
        this.PropertySubType = 'DUPLEX/TRIPLEX';
      } else if (
        this.historyState.PropertySubType &&
        (this.historyState.PropertySubType.toLowerCase() == 'townhouse' ||
          this.historyState.PropertySubType.toLowerCase() == 'townhouse')
      ) {
        this.PropertySubType = 'TOWNHOUSE';
      } else if (
        this.historyState.PropertySubType &&
        (this.historyState.PropertySubType.toLowerCase() ==
          'manufactured on land' ||
          this.historyState.PropertySubType.toLowerCase() == 'land')
      ) {
        this.PropertySubType = 'LAND';
      } else {
        this.PropertySubType = 'Other';
      }
      this.historyState['PropertySubType'] = this.PropertySubType;
      this.historyState['BedroomsTotal'] = this.BedroomsTotal;
      this.historyState['BathroomsHalf'] = this.BathroomsHalf;
      this.historyState['BathroomsFull'] = this.BathroomsFull;
      this.historyState['LivingArea'] = this.LivingArea;

      if (!this.myListingId) {
        this.checkPropertyAddress(userId);
      }
      this.showPreSelectedValue(this.historyState);
    }
  }

  checkPropertyAddress(userId) {
    let input = {
      where: {
        matchAddress: this.historyState.matchAddress,
        stage: 3,
        stripePaymentStatus: 'paid',
      },
    };

    this.myListingsService.GetListings(input).subscribe({
      next: (res) => {
        if (res && res.length > 0) {
          this.hideContinue = true;
          this.historyState.hideContinue = true;
          this.toastService.toast(
            'A listing with same property address is there in someones Listings',
            ToastType.Error
          );
        } else {
          this.saveMyListings(userId);
          this.hideContinue = false;
        }
      },
      error: (err) => {
        this.isButtonLoader = false;
        this.hideContinue = false;
        this.saveMyListings(userId);
        console.log('GetListings err : ', err);
      },
    });
  }

  triggerMail(propertyDetails) {
    let submitListingNotification =
      this.appState?.companyInfoValue?.sellSideConfig
        ?.submitListingNotification;
    let userType = this.userState?.getUserDetails?.userType;
    if (
      this.historyState.myHomeId &&
      userType == 'investor' &&
      submitListingNotification
    ) {
      let params = {
        propertyDetails: propertyDetails,
        action: 'submitListing',
      };
      this.myListingsService.notifyListMyHome(params).subscribe({
        next: (res) => {},
        error: (err) => {},
      });
    }
  }

  updateActivityLog() {
    let userType = this.userState?.getUserDetails?.userType;
    if (userType == 'investor') {
      let userId = this.userState?.getUserDetails?.id;
      let loggerParams = {
        category: constants.LOGGER.listMyProperty.category,
        action: constants.LOGGER.listMyProperty.action.choosePlan.key,
        data: {
          userId: userId,
          propertyId: this.historyState.listingDetails?.PMXPropertyId,
        },
      };
      this.activityLoggerService.updateActivityLog(loggerParams).subscribe({
        next: (res) => {},
        error: (err) => {},
      });
    }
  }

  showMyHomeDetails(myHomeId) {
    let params = {
      myHomeId: myHomeId,
    };

    this.myListingsService.getMyHomeDetails(params).subscribe({
      next: (res) => {
        if (res && res.data) {
          this.myHomeDetails = res.data;
          this.Basement =
            typeof this.myHomeDetails.basement === 'string'
              ? [
                  this.myHomeDetails.basement.charAt(0).toUpperCase() +
                    this.myHomeDetails.basement.slice(1).toLowerCase(),
                ]
              : this.myHomeDetails.basement
              ? this.myHomeDetails.basement
              : null;
          this.LivingArea = this.myHomeDetails.livingAreaSize
            ? this.myHomeDetails.livingAreaSize
            : null;
          this.BedroomsTotal = this.myHomeDetails.bedroomsTotal
            ? this.myHomeDetails.bedroomsTotal
            : null;
          this.BathroomsHalf = this.myHomeDetails.bathroomsHalf
            ? this.myHomeDetails.bathroomsHalf
            : null;
          this.BathroomsFull = this.myHomeDetails.bathroomsFull
            ? this.myHomeDetails.bathroomsFull
            : null;
          this.LotSizeSqFt = this.myHomeDetails.lotSize
            ? this.myHomeDetails.lotSize
            : null;
          this.Heating =
            this.myHomeDetails.heating && this.myHomeDetails.heating.length
              ? this.myHomeDetails.heating
              : null;
          this.Cooling =
            this.myHomeDetails.cooling && this.myHomeDetails.cooling.length
              ? this.myHomeDetails.cooling
              : null;

          if (
            this.myHomeDetails.propertySubType == 'Single Family Residence' ||
            this.myHomeDetails.propertySubType == 'house'
          )
            this.PropertySubType = 'HOUSE';
          else if (
            this.myHomeDetails.propertySubType == 'Condominium' ||
            this.myHomeDetails.propertySubType == 'condo'
          )
            this.PropertySubType = 'CONDO';
          else if (
            this.myHomeDetails.propertySubType == 'Quadruplex' ||
            this.myHomeDetails.propertySubType == 'duplex/triplex'
          )
            this.PropertySubType = 'DUPLEX/TRIPLEX';
          else if (this.myHomeDetails.propertySubType == 'Townhouse')
            this.PropertySubType = 'TOWNHOUSE';
          else if (
            this.myHomeDetails.propertySubType == 'manufactured on land' ||
            this.myHomeDetails.propertySubType == 'land'
          )
            this.PropertySubType = 'LAND';
          else {
            this.PropertySubType = 'Other';
          }
          this.historyState['PropertySubType'] = this.PropertySubType;
          this.historyState['BedroomsTotal'] = this.BedroomsTotal;
          this.historyState['BathroomsHalf'] = this.BathroomsHalf;
          this.historyState['BathroomsFull'] = this.BathroomsFull;
          this.historyState['LivingArea'] = this.LivingArea;
          this.historyState['Heating'] = this.Heating;
          this.historyState['Cooling'] = this.Cooling;
          this.historyState['Basement'] = this.Basement;
        }
        if (!this.myListingId) {
          this.checkPropertyAddress(this.userState?.getUserDetails?.id);
        }
        this.showPreSelectedValue(this.historyState);
      },
      error: (err) => {
        if (!this.myListingId) {
          this.checkPropertyAddress(this.userState?.getUserDetails?.id);
        }
        this.showPreSelectedValue(this.historyState);
        console.log('myHomeDetails err : ', err);
      },
    });
  }

  saveMyListings(userId) {
    let input = {
      userId: userId,
      stage: 1,
      stageName: 'Home Details',
      minSavings: this.historyState.minSavings,
      maxSavings: this.historyState.maxSavings,
      createdDate: new Date(),
      fullAddress: this.historyState.address,
      matchAddress: this.historyState.matchAddress,
      FIPS: this.historyState.FIPS,
      myHomeId: this.historyState.myHomeId,
      imgUrl: this.historyState.imgUrl,
      BedroomsTotal: this.BedroomsTotal,
      BathroomsFull: this.BathroomsFull,
      BathroomsHalf: this.BathroomsHalf,
      LivingArea: this.LivingArea,
      LotSizeSqFt: this.LotSizeSqFt,
      Heating: this.Heating,
      Cooling: this.Cooling,
      Basement: this.Basement,
      YearBuilt:
        this.historyState.listingDetails &&
        this.historyState.listingDetails.YearBuilt
          ? typeof this.historyState.listingDetails.YearBuilt == 'string'
            ? parseInt(this.historyState.listingDetails.YearBuilt)
            : this.historyState.listingDetails.YearBuilt
          : this.historyState.propertyDetails &&
            this.historyState.propertyDetails.YearBuilt
          ? typeof this.historyState.propertyDetails.YearBuilt == 'string'
            ? parseInt(this.historyState.propertyDetails.YearBuilt)
            : this.historyState.propertyDetails.YearBuilt
          : null,
      Stories: this.Stories,
      ListPrice: null,
      StreetAddress: this.historyState.StreetAddress,
      City: this.historyState.City,
      StateOrProvince: this.historyState.StateOrProvince,
      PostalCode: this.historyState.PostalCode,
      UnitNumber: this.historyState.UnitNumber,
      PropertySubType: this.PropertySubType,
      TaxAmount: null,
      TaxYear: null,
      PMXPropertyId:
        this.historyState.propertyDetails &&
        this.historyState.propertyDetails.PMXPropertyId
          ? typeof this.historyState.propertyDetails.PMXPropertyId == 'number'
            ? this.historyState.propertyDetails.PMXPropertyId.toString()
            : this.historyState.propertyDetails.PMXPropertyId
          : this.historyState.listingDetails &&
            this.historyState.listingDetails.PMXPropertyId
          ? typeof this.historyState.listingDetails.PMXPropertyId == 'number'
            ? this.historyState.listingDetails.PMXPropertyId.toString()
            : this.historyState.listingDetails.PMXPropertyId
          : null,
    };

    input = this.filterInputJson(input);

    this.myListingsService.CreateListing(input).subscribe({
      next: (res) => {
        if (res) {
          this.myListingId = res.id;
          this.historyState['myListingId'] = this.myListingId;
          this.localStorageService.set('myListingId', this.myListingId);
        } else {
          console.log('CreateListing Fails!!!!');
        }
      },
      error: (err) => {
        console.log('CreateListing err!!!! :', err);
      },
    });
  }

  saveBasicListingDetails(flag) {
    this.submitFlag = flag;
    this.dialogRef?.close();
    this.formService.submitForm();
  }

  updateListings(listingDetailsResponse?) {
    this.basicHomeData = listingDetailsResponse;

    this.historyState.UnitNumber = listingDetailsResponse.UnitNumber;
    this.historyState.StreetAddress = listingDetailsResponse.StreetAddress;
    this.historyState.City = listingDetailsResponse.City;
    this.historyState.StateOrProvince = listingDetailsResponse.StateOrProvince;
    this.historyState.PostalCode = listingDetailsResponse.PostalCode;

    let address =
      listingDetailsResponse.StreetAddress +
      ', ' +
      listingDetailsResponse.City +
      ', ' +
      listingDetailsResponse.StateOrProvince +
      ' ' +
      listingDetailsResponse.PostalCode;

    if (
      listingDetailsResponse.UnitNumber &&
      listingDetailsResponse.UnitNumber != ''
    ) {
      address = listingDetailsResponse.UnitNumber + ' ' + address;
    }

    this.historyState.address = address;
    this.basicHomeData['fullAddress'] = this.historyState.address;

    this.historyState.matchAddress = address
      .replace(/[\s,]+/g, '')
      .toLocaleLowerCase();
    this.basicHomeData['matchAddress'] = this.historyState.matchAddress;

    let userDetails = this.userState?.getUserDetails;
    if (userDetails && userDetails?.id) {
      let userUpdateInfo = {
        leadStatus: 1,
        investorId: userDetails.id,
      };
      if (
        listingDetailsResponse.BuyingNext === 'Yes' &&
        userDetails?.leadType === 'seller'
      ) {
        userUpdateInfo['leadType'] = 'buyer_seller';
        this.updateUserLeadStatus(userUpdateInfo);
      } else if (
        listingDetailsResponse.BuyingNext === 'No' &&
        userDetails?.leadType === 'buyer_seller'
      ) {
        userUpdateInfo['leadType'] = 'seller';
        this.updateUserLeadStatus(userUpdateInfo);
      }
    }

    if (this.historyState?.isPaymentDone) {
      this.basicHomeData['updateListing'] = true;
    }

    this.updateMyListings(this.submitFlag);
  }

  updateMyListings(submit) {
    if (
      !this.historyState.completedIndex ||
      this.historyState['completedIndex'] < 1.1
    ) {
      this.basicHomeData['stage'] = 1.1;
    }

    if (this.historyState.stageName) {
      if (
        this.historyState.stageName.split(',').indexOf('Listing Details') <= -1
      ) {
        this.basicHomeData['stageName'] =
          'Listing Details' + ',' + this.historyState.stageName;
      }
    } else {
      this.basicHomeData['stageName'] =
        'Listing Details' + ',' + 'Home Details';
    }

    this.basicHomeData['updatedDate'] = new Date();

    this.basicHomeData = this.filterInputJson(this.basicHomeData);

    this.myListingsService
      .UpdateListing(this.myListingId, this.basicHomeData)
      .subscribe({
        next: (res) => {
          if (
            !this.historyState.completedIndex ||
            this.historyState['completedIndex'] < 1.1
          ) {
            this.historyState['completedIndex'] = 1.1;
          }
          this.historyState['basicHomeData'] = this.basicHomeData;
          if (this.basicHomeData['FIPS']) {
            this.historyState.FIPS = this.basicHomeData['FIPS'];
          }
          this.historyState.stageName = this.basicHomeData['stageName'];
          this.isLoader = false;

          if (submit == 'save&wait') {
            this.formControlTouch = false;
            this.toastService.toast(
              'Listing details updated successfully!!!',
              ToastType.Information
            );
          } else if (submit == 'skip') {
            this.updateActivityLog();
            this.historyState['completedIndex'] = 1.7;
            this.router.navigateByUrl('/plans', {
              state: this.historyState,
            });
          } else if (submit == 'save&close') {
            this.router.navigateByUrl('/my-listing', {
              state: this.historyState,
            });
          } else if (submit == 'save&switch') {
            this.router.navigateByUrl('/photos', {
              state: this.historyState,
            });
          } else if (submit == 'skipPlan') {
            this.historyState['completedIndex'] = 1.1;
            this.triggerMail(this.historyState.listingDetails);
            this.updateActivityLog();
            this.router.navigateByUrl('/my-listing', {
              state: this.historyState,
            });
          }
        },
        error: (err) => {
          console.log('UpdateListing err!!!!', err);
          this.isLoader = false;
        },
      });
  }

  onFormValueChanged(event: { name: string; value: any }) {
    if (event.name === 'ListPrice') {
      if (event.value) {
        let y =
          typeof event.value === 'string'
            ? event.value.replace(/,/g, '')
            : event.value;
        let x = parseInt(y, 10);

        this.historyState.ListPrice = x;
        let minSavings = Math.round(x * 0.03 - 590);
        this.historyState.minSavings = minSavings < 0 ? 0 : minSavings;
        let maxSavings = Math.round(x * 0.05 - 590);
        this.historyState.maxSavings = maxSavings < 0 ? 0 : maxSavings;
      }
    }
  }

  updateUserLeadStatus(userUpdateInfo) {
    this.userService.updateLeadStatus(userUpdateInfo).subscribe({
      next: (res) => {
        let userEmail = this.userState?.getUserDetails?.email;
        if (userEmail) {
          this.header.getUserInfo(userEmail);
        }
      },
      error: (err) => {
        console.log('updateLeadStatus err : ', err);
      },
    });
  }

  switchTab(event) {
    if (event == 1) {
      if (this.formControlTouch) {
        this.closeFlag = 'close&switch';
        this.saveFlag = 'save&switch';
        this.stepperSaveComponent.updateSelectedTab('Listing Details');
        this.dialogRef = this.dialog.open(this.confirmationDialog);
        this.cdr.detectChanges();
      } else {
        this.router.navigateByUrl('/photos', {
          state: this.historyState,
        });
      }
    }
  }

  closeDialog(flag) {
    this.dialogRef.close();
    if (flag == 'close&continue') {
      this.router.navigateByUrl('/my-listing', {
        state: this.historyState,
      });
    } else if (flag == 'close&switch') {
      this.router.navigateByUrl('/photos', {
        state: this.historyState,
      });
    }
  }

  close() {
    if (this.formControlTouch) {
      this.closeFlag = 'close&continue';
      this.saveFlag = 'save&close';
      this.dialogRef = this.dialog.open(this.confirmationDialog);
    } else {
      this.router.navigateByUrl('/my-listing', {
        state: this.historyState,
      });
    }
  }

  onFormControlTouched(event: { name: string; touched: boolean }) {
    this.formControlTouch = event.touched;
  }

  filterInputJson(obj) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] == null || Number.isNaN(obj[key])) {
        delete obj[key];
      }
    });
    return obj;
  }
}
